import { ActionHandler } from "..";
import { onStartSurvey } from "./onStartSurvey";
import getStore from "src/utils/redux/store";
import { trackBuyflowEvent } from "src/utils/api/tracker";
import { trackCurrentTierEvent } from "src/utils/counterOffer";
import { onCompleteSurvey } from "./onCompleteSurvey";
import { trackCancellationSurveyFinished } from "src/components/counter-offer/tracking";
import saveToBraze from "src/utils/brazeUploader";

export const onStartCancellationSurvey: ActionHandler = (actionConfig) => {
  onStartSurvey(actionConfig);
  const { serverContext } = getStore().getState();

  trackBuyflowEvent("CancellationSurveyStarted", {
    subscriptionId: serverContext.subscription_id,
  });
  saveToBraze({
    event: {
      event_name: "CancellationSurveyStarted",
      event_data: { subscriptionId: serverContext.subscription_id },
    },
  });

  trackCurrentTierEvent();
};

export const onCompleteCancellationSurvey: ActionHandler = (actionConfig) => {
  trackCancellationSurveyFinished();
  onCompleteSurvey(actionConfig);
};
